import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type PromoCodeModuleSpecsFragment } from '../../../../api/fragments/PromoCodeModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import PromoCodeModuleUpdateForm from './PromoCodeModuleUpdateForm';

export type PromoCodeModuleUpdateDrawerProps = {
    module: PromoCodeModuleSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const PromoCodeModuleUpdateDrawer = ({ module, onClose, visible }: PromoCodeModuleUpdateDrawerProps) => {
    const { t } = useTranslation(['promoCodeModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('promoCodeModuleDetails:updateDrawer.cancelButton')}</Button>
                    <Button form="updatePromoCodeModule" htmlType="submit" type="primary">
                        {t('promoCodeModuleDetails:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('promoCodeModuleDetails:updateDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <PromoCodeModuleUpdateForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default PromoCodeModuleUpdateDrawer;

export const useUpdatePromoCodeModuleDrawer = (module: PromoCodeModuleUpdateDrawerProps['module']) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <PromoCodeModuleUpdateDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
